export default __webpack_public_path__ + "static/media/login-coach.84fce103.jpg";